import { useCallback, useEffect, useMemo, useState, useRef } from "react";
import { useDispatch, useStore } from "react-redux";
import xss from "xss";

import { MaxShipmentError } from "./errors/MaxShipmentError";
import CONFIG from "../config";
import Price from "../type/price";
import { basketActions } from "../actions";

// import NODE_MAPPING from "../data/deubaNodeMapping.json";

const ShippingChoiceSearch = (props) => {
  const { basketStorage, configStorage, kundenStorage, mandantStorage } = useStore().getState();
  const [filiale, setFiliale] = useState(null);
  const [filialeSearchTerm, setFilialeSearchTerm] = useState("");
  const [isFilialeDropdownOpen, setFilialeDropdownOpen] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const dispatch = useDispatch();
  // const nodeMapping = NODE_MAPPING.nodemapping;

  const buttonRefs = useRef([]); // For managing keyboard focus

  // const deubaNodes = useMemo (() => {
  //   if (!Array.isArray(nodeMapping)) {
  //     return [];
  //   } else {
  //     return nodeMapping.map(filiale => {
  //       return {
  //         nodeId: filiale.nodeId,
  //         strasse1: filiale.strasse1,
  //         childNodeIds: filiale.childNodeIds
  //       };
  //     });
  //   }
  // }, [nodeMapping]);

  // Helper to reset highlighted index
  const resetHighlight = () => setHighlightedIndex(-1);

  // handleUpdateBasketSum remains unchanged
  const handleUpdateBasketSum = useCallback((e) => {
    if (!e || !e.target) return;
    dispatch(basketActions.setDoShip(xss(e.target.value)));
    dispatch(basketActions.updateSum());
    if (e.target.value === "yes") {
      setFiliale(null);
      setFilialeSearchTerm("");
      setFilialeDropdownOpen(false);
      resetHighlight();
    }
  }, [dispatch]);

  // Synchronize filiale with basketStorage
  useEffect(() => {
    const filialen = basketStorage.getFilialen(configStorage.isKundenShop());
    if (filiale && !filialen.find(f => f.value === Number(filiale))) setFiliale(null);
    if (!basketStorage.hasShippingChoice || configStorage.isAnkaufShop()) {
      basketStorage.doShip = "no";
    }
  }, [basketStorage, configStorage, filiale]);

  const handleSelectedFiliale = useCallback((filialeOption) => {
    if (!filialeOption) return;
    const { value, label } = filialeOption;
    const f = (basketStorage.filialen || []).find(f => Number(f.value) === Number(value)) || null;
    dispatch(basketActions.setSelectedFiliale(f));
    setFiliale(value);
    setFilialeSearchTerm(label);
    setFilialeDropdownOpen(false);
    resetHighlight();
  }, [basketStorage.filialen, dispatch]);

  const filialen = useMemo(() => {
    // Filter filialen based on user rights and configuration
    // if (configStorage.isDeuBa() && !checkRageRight(rightStorage.currentRight, [RAGE_RIGHT.RAGE_ADMIN])) {
    //   if (authenticationStorage._user) {
    //     const beraterNodeId = authenticationStorage._user.platz;
    //     if (beraterNodeId) {
    //       const beraterFilialen = deubaNodes.filter(item => item.nodeId === beraterNodeId || item.childNodeIds.includes(beraterNodeId));
    //       if (beraterFilialen && beraterFilialen.length > 0) {
    //         return basketStorage.getFilialen(configStorage.isKundenShop()).filter(item => item.name === beraterFilialen[0].strasse1);
    //       } else {
    //        return basketStorage.getFilialen(configStorage.isKundenShop());
    //       }
    //     } else {
    //       return basketStorage.getFilialen(configStorage.isKundenShop());
    //     }
    //   } else {
    //     return basketStorage.getFilialen(configStorage.isKundenShop());
    //   }
    // } else {

    // Alle User sehen alle Filialen ( Termin mit DeuBa 13.01.2026 )
      return basketStorage.getFilialen(configStorage.isKundenShop());
    // }
  }, [basketStorage, configStorage]);

  const filteredFilialen = useMemo(() => {
    if (!filialeSearchTerm) return filialen;
    const lowerTerm = filialeSearchTerm.toLowerCase();
    return filialen.filter(f => f.name.toLowerCase().includes(lowerTerm));
  }, [filialeSearchTerm, filialen]);

  const handleInputChange = (e) => {
    setFilialeSearchTerm(e.target.value);
    setFiliale(null);
    setFilialeDropdownOpen(true);
    resetHighlight();
  };

  const handleInputFocus = () => {
    setFilialeSearchTerm("");
    setFilialeDropdownOpen(true);
  };

  // Keyboard navigation handler
  const handleKeyDown = (e) => {
    if (!isFilialeDropdownOpen || filteredFilialen.length === 0) return;
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex(prev => Math.min(prev + 1, filteredFilialen.length - 1));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex(prev => Math.max(prev - 1, -1));
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (highlightedIndex >= 0 && highlightedIndex < filteredFilialen.length) {
        handleSelectedFiliale({ value: filteredFilialen[highlightedIndex].value, label: filteredFilialen[highlightedIndex].name });
      }
    } else if (e.key === "Escape") {
      setFilialeDropdownOpen(false);
    }
  };

  const options = filteredFilialen.map(f => ({ value: f.value, label: f.name }));

  // Generate IDs for accessibility
  const comboBoxId = "filiale-combobox";
  const listboxId = "filiale-listbox";

  const minOrderValueFiliale = mandantStorage && typeof mandantStorage.getMinOrdervalueFiliale === "function"
    ? Number(mandantStorage.getMinOrdervalueFiliale())
    : 0;

  //console.info("ShippingChoiceSearch - hasFilialChoice: ", basketStorage.hasFilialChoice);

  return (
    <div className="ser-shipping">
      {basketStorage.hasShippingChoice && !configStorage.isAnkaufShop() ? (
        <div
          className="ser-textpanel ser-shipopts form-check"
          aria-label="Ihre Versandoptionen:"
        >
          <span className="ser-label ser-iblock">Ihre Versandoptionen:</span>
          {basketStorage.hasFilialen() && (
            <span className="ser-shipopt ser-iblock">
              <input
                id="serDontShip"
                type="radio"
                name="serDoShip"
                className="form-check-input"
                value="no"
                checked={basketStorage.doShip === "no"}
                onChange={handleUpdateBasketSum}
                disabled={basketStorage.locked}
              />
              <label className="ser-shipopt-label form-check-label" htmlFor="serDontShip">
                Abholung in der Filiale
              </label>
            </span>
          )}
          { (!configStorage.isDeuBa() || 
            (!!kundenStorage.getKunde().ort && 
             !!kundenStorage.getKunde().plz && !!kundenStorage.getKunde().strasse1)) ?
            (<span className="ser-shipopt ser-iblock form-check">
              <input
                id="serDoShip"
                type="radio"
                name="serDoShip"
                className="form-check-input"
                value="yes"
                checked={basketStorage.doShip === "yes"}
                onChange={handleUpdateBasketSum}
                disabled={basketStorage.locked}
              />
              <label className="ser-shipopt-label form-check-label" htmlFor="serDoShip">
                Direktversand nach Hause
              </label>
            </span>) : null
          }
        </div>
      ) : (
        <MaxShipmentError />
      )}

      {basketStorage.sumLessthanMinOdervalueFiliale && !configStorage.isAnkaufShop()
        ? (
          <div className="ser-textpanel ser-grey">
            Abholung in Ihrer Bank ist nur über <strong className="text-primary">{Price.markify(minOrderValueFiliale)}</strong> EUR möglich.
          </div>
        )
        : null
      }

      {basketStorage.hasFilialChoice && (
        <div className="ser-textpanel ser-filialpanel">
          <span className="ser-iblock ser-label" id="labelFilialen">
            {!configStorage.isAnkaufShop() ? "Bitte wählen Sie Ihre Filiale:" : "Ablieferfiliale:"}
          </span>
          <div style={{ position: "relative" }}>
            {/* Combobox container */}
            <input
              type="text"
              className="form-control"
              aria-labelledby="labelFilialen"
              aria-autocomplete="list"
              aria-controls={listboxId}
              aria-expanded={isFilialeDropdownOpen}
              role="combobox"
              id={comboBoxId}
              placeholder="Filiale suchen..."
              value={filialeSearchTerm}
              onChange={handleInputChange}
              onFocus={handleInputFocus}
              onKeyDown={handleKeyDown}              
            />

            {/* Options list (Listbox) */}
            {isFilialeDropdownOpen && options.length > 0 && (
              <div
                id={listboxId}
                role="listbox"
                aria-labelledby={comboBoxId}
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  right: 0,
                  maxHeight: filialen.length >= 10 ? "300px" : `${filialen.length * 20 + 20}px`, // dynamically set
                  overflowY: "auto",
                  border: "1px solid #ccc",
                  background: "#fff",
                  zIndex: 999,
                }}
              >
                {options.map((opt, index) => (
                  <button
                    key={opt.value}
                    id={`${comboBoxId}-option-${index}`}
                    role="option"
                    aria-selected={highlightedIndex === index}
                    onMouseDown={() => handleSelectedFiliale(opt)}
                    onMouseEnter={() => setHighlightedIndex(index)}
                    onFocus={() => setHighlightedIndex(index)}
                    ref={(el) => (buttonRefs.current[index] = el)}
                    style={{
                      display: "block",
                      width: "100%",
                      padding: "8px",
                      background: index === highlightedIndex ? "#eee" : "white",
                      border: "none",
                      textAlign: "left",
                      cursor: "pointer",
                      outline: "none",
                      color: "#16184E"
                    }}
                    tabIndex={-1}
                  >
                    {opt.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {CONFIG.isSortenShop() && (
        <div className="ser-textpanel ser-grey">
          Informationen zu Währungen, Ein- und Ausfuhrbestimmungen und
          weiterführende Details finden Sie{" "}
          <a
            className="ser-link"
            href="https://www.bacosystem.de/bayernlb.php"
            target="_blank"
            rel="noopener noreferrer"
            title="Informationen zu Währungen, Ein- und Ausfuhrbestimmungen und weiterführende Details"
            aria-label="Informationen zu Währungen, Ein- und Ausfuhrbestimmungen und weiterführende Details"
          >
            hier
          </a>
          .
        </div>
      )}
    </div>
  );
};

export default ShippingChoiceSearch;